// extracted by mini-css-extract-plugin
export var connectionButton = "_6x-1";
export var rightPanel = "_6x-3";
export var stepDescription = "_6x-2";
export var stepIcon = "_6x-0";